import React from 'react';
import { FaBookOpen, FaDownload, FaExternalLinkAlt } from 'react-icons/fa';
import './ProgrammeBookCard.css';

// Download card for the admin-uploaded ICES2026 Conference Programme Book (PDF).
// Pass the object from fetchProgrammeBook(); renders nothing when it is null.
const formatBytes = (n) => {
  const v = Number(n || 0);
  if (!v) return '';
  if (v >= 1024 * 1024) return `${(v / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(v / 1024))} KB`;
};

const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
};

const ProgrammeBookCard = ({ book }) => {
  if (!book) return null;
  const meta = ['PDF', formatBytes(book.size), formatDate(book.updatedAt) && `Updated ${formatDate(book.updatedAt)}`]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className="programme-book-card">
      <div className="programme-book-icon" aria-hidden="true">
        <FaBookOpen />
      </div>
      <div className="programme-book-text">
        <h3 className="programme-book-title">{book.title}</h3>
        {book.note && <p className="programme-book-note">{book.note}</p>}
        <p className="programme-book-meta">{meta}</p>
      </div>
      <div className="programme-book-actions">
        <a className="programme-book-btn programme-book-btn--primary" href={book.downloadUrl} download>
          <FaDownload /> Download
        </a>
        {book.viewUrl && (
          <a className="programme-book-btn programme-book-btn--secondary" href={book.viewUrl} target="_blank" rel="noopener noreferrer">
            <FaExternalLinkAlt /> View online
          </a>
        )}
      </div>
    </div>
  );
};

export default ProgrammeBookCard;
